const menu = {
    label: 'Hospedagem e Eventos',
    icon: 'pi pi-fw pi-building',
    to: '/solicitacoes/hospedagem',
    matchChildren: true,
    rules: ['HOSPEDAGEM-00'],
};

export default menu;
